const config = {
	api: 'https://path-uat.ust.hk/path/api',
	asset: 'https://path-uat.ust.hk/path/asset',
	loginTimeout: 18000000
};

export default config;
